/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BookingSessionItemDto = {
    /**
     * Session UUID
     */
    id: string;
    /**
     * Session status
     */
    status: BookingSessionItemDto.status | null;
    /**
     * Scheduled start time
     */
    scheduledStartTime: string;
    /**
     * Scheduled end time
     */
    scheduledEndTime: string;
    /**
     * Session number
     */
    sessionNumber: number;
    /**
     * Attendance status
     */
    attendanceStatus: BookingSessionItemDto.attendanceStatus | null;
    /**
     * Latest reschedule request status for this session
     */
    rescheduleStatus?: BookingSessionItemDto.rescheduleStatus;
    /**
     * Latest requested new start time for reschedule
     */
    newStartTime?: string | null;
    /**
     * Latest requested new end time for reschedule
     */
    newEndTime?: string | null;
};
export namespace BookingSessionItemDto {
    /**
     * Session status
     */
    export enum status {
        SCHEDULED = 'scheduled',
        IN_PROGRESS = 'in_progress',
        COMPLETED = 'completed',
        CANCELLED = 'cancelled',
        RESCHEDULED = 'rescheduled',
    }
    /**
     * Attendance status
     */
    export enum attendanceStatus {
        PENDING = 'pending',
        MARKED = 'marked',
        ACCEPTED = 'accepted',
        REJECTED = 'rejected',
    }
    /**
     * Latest reschedule request status for this session
     */
    export enum rescheduleStatus {
        PENDING = 'pending',
        ACCEPTED = 'accepted',
        DECLINED = 'declined',
    }
}

